import React from "react";
import { ShoppingBag, X } from "lucide-react";
import QuantityStepper from "./QuantityStepper";

const gbp = (n) =>
  new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" }).format(
    n
  );

const OrderSummary = ({
  lines,
  subtotal,
  notice,
  onRemove,
  onQtyChange,
  onCheckout,
  checkoutLabel = "CHECKOUT",
}) => {
  return (
    <div className="bg-white rounded-md shadow-xl border border-[#d9c3a8] overflow-hidden">
      <div className="bg-[#9b3d0a] px-6 py-4 flex items-center gap-3">
        <ShoppingBag size={20} className="text-[#f2e5de]" />
        <h3 className="text-[#ebc754] font-semibold tracking-[0.12em] text-sm uppercase">
          Your Order
        </h3>
      </div>

      <div className="p-6">
        {notice && (
          <div className="mb-4 rounded-md border border-[#e0c9ad] bg-[#f3e7d6] px-4 py-3 text-sm text-[#6e5646]">
            {notice}
          </div>
        )}
        {lines.length === 0 ? (
          <p className="text-[#7a6a58] text-sm py-6 text-center">
            Your basket is empty. Select a ticket to begin.
          </p>
        ) : (
          <ul className="space-y-5">
            {lines.map((l) => (
              <li key={l.id} className="border-b border-[#eee3d2] pb-4 last:border-b-0 last:pb-0">
                <div className="flex items-start justify-between gap-3">
                  <div className="flex-1 min-w-0">
                    <p className="text-[#1e231f] text-sm font-medium leading-snug">
                      {l.name}
                    </p>
                    <p className="text-[#7a6a58] text-xs mt-1">
                      {gbp(l.price)} / {l.unit}
                    </p>
                  </div>
                  <div className="text-right shrink-0">
                    <p className="text-[#1e231f] text-sm font-semibold">
                      {gbp(l.price * l.qty)}
                    </p>
                    {onRemove && (
                      <button
                        type="button"
                        onClick={() => onRemove(l.id)}
                        className="text-[#b5a48f] hover:text-[#9b3d0a] transition-colors mt-1"
                        aria-label={`Remove ${l.name}`}
                      >
                        <X size={15} />
                      </button>
                    )}
                  </div>
                </div>

                <div className="mt-3 flex items-center justify-between gap-3">
                  <span className="text-xs text-[#9a876f]">Quantity</span>
                  {onQtyChange ? (
                    <QuantityStepper
                      value={l.qty}
                      onChange={(q) => onQtyChange(l.id, q)}
                      max={typeof l.max === "number" ? l.max : undefined}
                      testId={`basket-qty-${l.id}`}
                    />
                  ) : (
                    <span className="bg-[#f2e5de] text-[#9b3d0a] text-xs font-bold rounded px-2 py-0.5">
                      {l.qty}×
                    </span>
                  )}
                </div>
              </li>
            ))}
          </ul>
        )}

        <div className="border-t border-[#d9c3a8] mt-6 pt-4 flex items-center justify-between">
          <span className="text-[#1e231f] font-semibold">Subtotal</span>
          <span className="feral-serif text-[#9b3d0a] text-2xl">
            {gbp(subtotal)}
          </span>
        </div>

        <button
          disabled={lines.length === 0}
          onClick={onCheckout}
          data-testid="checkout-button"
          className="w-full mt-5 bg-[#9b3d0a] hover:bg-[#7e3208] disabled:opacity-40 disabled:cursor-not-allowed text-[#f2e5de] py-3.5 rounded-full tracking-[0.15em] text-sm font-semibold transition-colors duration-300"
        >
          {checkoutLabel}
        </button>
        <p className="text-[11px] text-center mt-3 text-[#9a876f]">
          Secure checkout · Tickets are non-refundable
        </p>
      </div>
    </div>
  );
};

export default OrderSummary;
